import { Injectable } from '@angular/core';
import {
  HomeFeedCard,
  HomeFeedCardRegister,
  HomeFeedSection,
  registerHomeFeedCard,
  removeHomeFeedCard,
} from '@brightside-web/desktop/feature/home-feed';
import { Store } from '@ngrx/store';


@Injectable({
  providedIn: 'root'
})
export class HomeFeedService {
  componentRegistry: { [key: string]: any } = {};

  constructor(
    private _store: Store
    ) {}

  /** Registers a component dynamically */
  registerComponent(key: string, component: any) {
    this.componentRegistry[key] = component;
  }

  /** Retrieves a registered component */
  getComponent(key: string): any {
    return this.componentRegistry[key];
  }

  registerHomeFeedCard(cardInfo: HomeFeedCardRegister) {
    this.registerComponent(cardInfo.component, cardInfo.componentRef);
    const {key, component, data, order, section} = cardInfo
    this._store.dispatch(registerHomeFeedCard({key, component, data, order, section}))
  }

  removeHomeFeedCard(key: string, section: HomeFeedSection) {
    this._store.dispatch(removeHomeFeedCard({ key, section }));
  }
}
